import React, { useEffect, useState } from "react";
import backicon from "./../../../../../../Assets/icons/backIcon.svg";
// import "./index.scss";
import { useLocation, useNavigate } from "react-router-dom";
import DynamicForm from "../../../../../customformComponent/customForm/DynamicForm";
import axiosInstance from "../../../../../services/api/API";
import Swal from 'sweetalert2';
import Loader from "../../../../../customComponents/CustomLoader";
import { Placeholder } from "react-bootstrap";

const VendorEdit = () => {
  const [formData, setFormData] = useState({});
  const [loading, setLoading] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});
  const [vendorType, setVendorType] = useState([]);
  const [userTypedd, setUserTypedd] = useState([]);
  const userType = localStorage.getItem("UserType");
  const businessPartnerId = localStorage.getItem("business_partner_id");
  const navigate = useNavigate();
  const Token = localStorage.getItem("authToken");
  const location = useLocation();
  const { data } = location.state || {};

  useEffect(() => {
    userTypedropdown();
  }, []);

  const userTypedropdown = async () => {
    try {
      const response = await axiosInstance.get("/bp-onboard/bplist", {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${Token}`,
        },
      });

      const data = response.data.data.data;
      const userTypeOptions = data.map((user) => ({
        value: user.onboard_id,
        label: user.bp_name,
      }));
      setUserTypedd(userTypeOptions);
    } catch (error) {
      console.log(error);
    }
  };
  const fetchVendorType = async () => {
    try {
      const response = await axiosInstance.get(
        `/vendortype/edit/${data.vendor_type_id}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${Token}`,
          },
        }
      );
      const fetchedData = response.data.data;
      const formatedDATA = {
        vendor_type_name: fetchedData.vendor_type_name,
        vendor_type_desc: fetchedData.vendor_type_desc,
        status: fetchedData.status === 1 ? "Active" : "Inactive",
        business_partner_id: fetchedData.business_partner_id,
      };
      setFormData(formatedDATA);
      setVendorType(fetchedData);
      console.log(formData, "HSNCODE DATA");
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchVendorType();
  }, []);


  const handleFormSubmit = async (formData) => {
    const errors = {};
    let isValid = true;
    VendorTYpeInputs.forEach((field) => {
      if (field.validation && field.validation.required) {
        if (!formData[field.name]) {
          errors[field.name] = "This field is required";
          isValid = false;
        }
      }
    });
    if (!isValid) {
      setValidationErrors(errors);
      return;
    }

    const confirmation = await Swal.fire({
      title: "Update Vendor Type",
      text: "Are you sure you want to update this record?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No, cancel",
    });
  
    // Proceed only if user confirms
    if (confirmation.isConfirmed) {
      try {
        setLoading(true);
        const payload = {
          business_partner_id: userType === "superadmin" ? formData.business_partner_id : businessPartnerId,
          vendor_type_name: formData.vendor_type_name,
          vendor_type_desc: formData.vendor_type_desc,
          status: formData.status === "Active" ? 1 : 0,
        };
        const response = await axiosInstance.patch(`/vendortype/update/${data.vendor_type_id}`, payload, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${Token}`,
          },
        });
  
        console.log("Update successful:", response.data);
        await Swal.fire({
          title: "Success",
          text: "Vendor Type updated successfully.",
          icon: "success",
          confirmButtonText: "OK",
        });
        navigate("/admin/manage-logistic/vender-type");
  
      } catch (error) {
        console.error("Error updating vendor type:", error);
        const errorMessage = error.response?.data?.message || "An error occurred while processing your request.";
        await Swal.fire({
          title: "Something went wrong",
          text: errorMessage,
          icon: "error",
          confirmButtonText: "OK",
        });
  
      } finally {
        setLoading(false);
      }
    } else {
      setLoading(false); 
    }
  };
  

  const backNavigate = () => {
    navigate("/admin/manage-logistic/vender-type");
  };

  const VendorTYpeInputs = [
    ...(userType === "superadmin"
      ? [
          {
            name: "business_partner_id",
            label: "Business Partner",
            type: "dropdown",
            required: true,
            options: userTypedd,
            gridClass: "col-lg-4",
          },
        ]
      : []),
    {
      name: "vendor_type_name",
      label: "Vendor Type",
      type: "text",
      required: true,
      Placeholder:"Enter Vendor Type",
      validation: {
        required: true,
        pattern: /^[A-Za-z\s]*$/,
        message: "Only alphabets are allowed*",
      },
      gridClass: "col-lg-4",
    },
    {
      name: "vendor_type_desc",
      label: "Description",
      type: "text",
      required: true,
      validation: { required: true },
      gridClass: "col-lg-4",
    },
    {
      name: "status",
      label: "Status",
      type: "dropdown",
      required: true,
      options: [
        { label: "Active", value: "Active" },
        { label: "Inactive", value: "Inactive" },
      ],
      validation: {
        required: true,
        message: "Status is required",
      },
      gridClass: "col-lg-4",
    },
  ];

  return (
    <>
      <div>
        {loading ? (
          <Loader />
        ) : (
          <>
            <div className="backbutton mt-2 mb-2">
              <img onClick={backNavigate} src={backicon} alt="back" />
              <span className="backbtntitle">Update Vendor Type</span>
            </div>
            <div className="form-container">
              <span className="cust-det-title mt-2 mb-2">
                Please Update the Vendor Type Details
              </span>
              <DynamicForm
                formConfig={VendorTYpeInputs}
                formData={formData}
                setFormData={setFormData}
                onSubmit={handleFormSubmit}
                validationErrors={validationErrors}
                setValidationErrors={setValidationErrors}
              />
            </div>

            <div className="btncontainer mt-3">
              <button
                onClick={() => {
                  handleFormSubmit(formData);
                }}
                className="submit-btn"
              >
                Submit
              </button>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default VendorEdit;
